import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=3fb6e81e&scoped=true&"
var script = {}
import style0 from "./BackButton.vue?vue&type=style&index=0&id=3fb6e81e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb6e81e",
  null
  
)

export default component.exports